import React from 'react';
import { connect } from 'react-redux';
import { withTranslation, WithTranslation } from "react-i18next";
import { dialog, UrlDialogInfo, app } from "@microsoft/teams-js";
import { getBaseUrl } from '../../configVariables';
import { duplicateDraftNotification } from '../../apis/messageListApi';
import { selectMessage, getMessagesList, getScheduledMessagesList, getDraftMessagesList } from '../../actions';
import { TFunction } from "i18next";
import { Menu, MenuTrigger, MenuButton, MenuPopover, MenuList, MenuItem } from '@fluentui/react-components';
import { MoreHorizontal24Regular, Info24Regular, SaveCopy24Regular } from '@fluentui/react-icons';

export interface OverflowProps extends WithTranslation {
    message?: any;
    styles?: object;
    title?: string;
    selectMessage?: any;
    getMessagesList?: any;
    getDraftMessagesList?: any;
    getScheduledMessagesList?: any;
}

export interface OverflowState {
}

export interface ITaskInfo {
    title?: string;
    height?: number;
    width?: number;
    url?: string;
    card?: string;
    fallbackUrl?: string;
    completionBotId?: string;
}

class Overflow extends React.Component<OverflowProps, OverflowState> {
    readonly localize: TFunction;
    constructor(props: OverflowProps) {
        super(props);
        this.localize = this.props.t;
        this.state = {
            menuOpen: false,
        };
    }

    public async componentDidMount() {
        await app.initialize();
    }

    public render(): JSX.Element {
        return <Menu >
            <MenuTrigger disableButtonEnhancement>
                <MenuButton onClick={e => e.stopPropagation()} icon={< MoreHorizontal24Regular />} appearance='transparent' />
            </MenuTrigger>
            <MenuPopover>
                <MenuList>
                    <MenuItem key='status' icon={<Info24Regular/>} onClick={this.onStatusClick}>{this.localize("ViewStatus")}</MenuItem>
                    <MenuItem key='duplicate' icon={<SaveCopy24Regular/>} onClick={this.onDuplicateClick}>{this.localize("Duplicate")}</MenuItem>
                </MenuList>
            </MenuPopover>
        </Menu>
    }

    private onStatusClick = (event: any) => {
        event.stopPropagation();
        let url = getBaseUrl() + "/viewstatus/" + this.props.message.id + "?locale={locale}";
        this.onOpenTaskModule(null, url, this.localize("ViewStatus"));
    }

    private onDuplicateClick = (event: any) => {
        event.stopPropagation();
        this.duplicateDraftMessage(this.props.message.id).then(() => {
            this.props.getDraftMessagesList();
        });
    }

    private onOpenTaskModule = (event: any, url: string, title: string) => {
        let taskInfo: UrlDialogInfo = {
            url: url,
            title: title,
            size: {
                height: 660,
                width: 1000
            },
            fallbackUrl: url,
        };
        let submitHandler = (result: dialog.ISdkResponse) => {
            this.props.getDraftMessagesList().then(() => {
                this.props.getMessagesList().then(() => {
                    this.props.getScheduledMessagesList();
                });

            });
        };
        dialog.url.open(taskInfo, submitHandler);
    }

    private duplicateDraftMessage = async (id: number) => {
        try {
            await duplicateDraftNotification(id);
        } catch (error) {
            return error;
        }
    }
}

const mapStateToProps = (state: any) => {
    return { messagesList: state.messagesList };
}

const overflowWithTranslation = withTranslation()(Overflow);
export default connect(mapStateToProps, { selectMessage, getScheduledMessagesList, getMessagesList, getDraftMessagesList })(overflowWithTranslation);
